/* lib/api/notifications.js — порт боевого клиента уведомлений.
 * Бэк скоупит по user (НЕ по workspace) → одно in-app событие на пользователя.
 * Контракт: {ok,status,data}. Список → {results, unread_count}.
 * Бэк теперь умеет двусторонний read-toggle (read/unread) и DELETE одного. */

import { apiFetch } from './client.js';

export const listNotifications = (opts = {}) => {
  const params = new URLSearchParams();
  if (opts.limit) params.set('limit', String(opts.limit));
  if (opts.unread) params.set('unread', '1');
  if (opts.type) params.set('type', opts.type);
  const qs = params.toString();
  return apiFetch(`/api/notifications/${qs ? `?${qs}` : ''}`);
};

export const markNotificationRead = (id) =>
  apiFetch(`/api/notifications/${id}/read/`, { method: 'POST', body: {} });

export const markNotificationUnread = (id) =>
  apiFetch(`/api/notifications/${id}/unread/`, { method: 'POST', body: {} });

export const deleteNotification = (id) =>
  apiFetch(`/api/notifications/${id}/`, { method: 'DELETE' });

export const markAllNotificationsRead = () =>
  apiFetch('/api/notifications/mark-all-read/', { method: 'POST', body: {} });

export const getNotificationPreferences = () =>
  apiFetch('/api/notifications/preferences/');

// preferences: [{type, email_enabled?, in_app_enabled?}] (пакет). Бэк возвращает полный список.
export const updateNotificationPreferences = (preferences) =>
  apiFetch('/api/notifications/preferences/', { method: 'PATCH', body: { preferences } });
